const BASE64_REGEXP = /data:(image|text).+;base64/;

const isBase64 = (string) => BASE64_REGEXP.test(string);

export default isBase64;
